export default {
  status: {
    active: "active",
    pending: "pending",
    canceled: "canceled",
    exchange: "exchange"
  }
};
